<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Trabalhos realizados</h2>
      <p>
        Confiança e credibilidade são características que deixarmos bem claras nos
        serviços prestados aos nossos clientes. Veja alguns de nossos trabalhos já realizados:
      </p>
      <div class="wrapper-clients-brand">
        <section v-for="(item, index) in clients" :key="index" class="unitary-brand">
          <a :href="item.link" target="_blank">
            <img :src="item.brand" :alt="item.alt" :class="{'diff': item.diff}"/>
          </a>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'clients-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      clients: [
        {
          name: 'Represente | Gestão de clientes',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandRepresente.svg',
          link: 'https://represente.com.br',
          alt: 'Represente | Gestão de clientes',
          diff: true,
        },
        {
          name: 'Aquecimento de Água',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandAquecimentoAgua.svg',
          link: 'https://aquecimentodeagua.com.br',
          alt: 'Aquecimento de Água',
        },
        {
          name: 'Rafaela Ingrid',
          brand: 'https://thiagoalmeida.com.br/img/clients/rafaelaIngrid_horizontal.svg',
          link: 'https://rafaelaingrid.com.br',
          alt: 'Rafaela Ingrid | Contabilidade, Controladoria, Audotoria',
        },
        {
          name: 'Thiago Almeida',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandThiagoAlmeida.svg',
          link: 'https://thiagoalmeida.com.br',
          alt: 'Thiago Almeida | Desenvolvedor Freont-end Apaixonado por HTML, CSS e Javascript e seus Frameworks',
        },
        {
          name: 'Diatech Representação & Consultoria',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandDiatech.svg',
          link: 'https://diatech.com.br',
          alt: 'Diatech Representação & Consultoria',
        },
        {
          name: 'Via Art Solar Tech',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandViaArt.svg',
          link: 'https://viaartsolartech.com',
          alt: 'Via Art Solar Tech',
        },
        {
          name: 'Parecer Contabil',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandParecerContabil.svg',
          link: '',
          alt: 'Parecer Contabil',
        },
        {
          name: 'Panificadora Palmeiras',
          brand: 'https://thiagoalmeida.com.br/img/clients/brandPanificadoraPalmeiras.svg',
          link: 'https://panificadorapalmeidas.com.br',
          alt: 'Panificadora Palmeiras',
          diff: true,
        },
      ],
    };
  },
  methods: {

  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  section
    width: 100%
    margin-bottom: 40px
  .global-box
    padding: 0 !important
    overflow: initial !important
    .wrapper-clients-brand
      display: flex
      flex-wrap: wrap
      justify-content: space-around
      margin-top: 40px
      .unitary-brand
        width: 30%
        margin-bottom: 24px
        a
          display: flex
          justify-content: center
          align-items: center
          height: 100px
        img
          max-width: 180px
          &.diff
            max-width: 150px
    @media (max-width: $widthTerciarySmall)
      p
        text-align: justify
      .content-box
        .wrapper-clients-brand
          .unitary-brand
            width: 100%
            img
              max-width: 60%
              &.diff
                max-width: 40%
</style>
